export default __webpack_public_path__ + "static/media/letter_en.34cc22d2.jpg";